export default class DebtNotice {
  public type: string;
  public debtSum: number;
  public dueDate: Date;
  public bailiff?: Bailiff;
}

export class Bailiff {
  public name: string;
  public phone: string;
  public email: string;
}
